import React from "react"

function Footer() {
	return (
		<footer className="site-footer">
			<p>
				© {new Date().getFullYear()} Shifting Sands Exp.{" "}
				<br className="mobile-break" />
				Designed by Max. Advertising Inc; <br className="mobile-break" />
				Developed by{" "}
				<a
					href="https://webloonstudio.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					Webloon Studio
				</a>
				. <br className="mobile-break" />
				All rights reserved.
			</p>
		</footer>
	)
}

export default Footer
